import { c as _c } from "react/compiler-runtime";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import type { ApiWave } from "@/generated/models/ApiWave";
import SelectGroupModalWrapper from "@/components/utils/select-group/SelectGroupModalWrapper";
import type { WaveGroupType } from "../WaveGroup.types";
import type { ApiUpdateWaveRequest } from "@/generated/models/ApiUpdateWaveRequest";
import { buildWaveUpdateBody } from "./buttons/utils/waveGroupEdit";
export default function WaveGroupEdit(t0) {
  const $ = _c(13);
  const {
    wave,
    type,
    isEditOpen,
    setIsEditOpen,
    onWaveUpdate
  } = t0;
  let t1;
  if ($[0] !== type || $[1] !== wave) {
    t1 = t2 => {
      const {
        group
      } = t2;
      return buildWaveUpdateBody(wave, type, group.id);
    };
    $[0] = type;
    $[1] = wave;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getBody = t1;
  let t2;
  if ($[3] !== getBody || $[4] !== onWaveUpdate || $[5] !== setIsEditOpen) {
    t2 = async group_0 => {
      const body = getBody({
        group: group_0
      });
      await onWaveUpdate(body);
      setIsEditOpen(false);
    };
    $[3] = getBody;
    $[4] = onWaveUpdate;
    $[5] = setIsEditOpen;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onGroupSelect = t2;
  let t3;
  if ($[7] !== setIsEditOpen) {
    t3 = () => setIsEditOpen(false);
    $[7] = setIsEditOpen;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isEditOpen || $[10] !== onGroupSelect || $[11] !== t3) {
    t4 = <SelectGroupModalWrapper isOpen={isEditOpen} onClose={t3} onGroupSelect={onGroupSelect} />;
    $[9] = isEditOpen;
    $[10] = onGroupSelect;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}